module.exports = __webpack_public_path__ + "img/recommed-img6.c535165a.jpg";